export default{
    service:'Service',
    services:'Services',
    serviceCategory: 'Service Category',
    serviceProperty: 'Service Property',
    serviceTitle: 'Title',
    serviceCode: 'Code',
    action: 'Action',
    editService:'Edit Service',
    addService:'Add Service',
    newServices:'New Services',
    discountGroup: 'Discount Group',
    serviceGroups: 'Service Groups',
    serviceGender: 'Service Gender',
    searchServiceByCategory: 'search Service By Category',
    searchByCode: 'search By Code',
}